<body>
    <div class="dash">
        <!-- Patient sidebar start here -->
        <!-- <app-patsidebar></app-patsidebar> -->
        <!-- Patient sidebar end here -->
        <div class="dash-app">
            <!-- Patient Header start here -->
            <!-- <app-patheader></app-patheader> -->
            <!-- Patient Header end here -->

            <!-- Patient Main Body start here -->

            <!-- Doctor,Hospitals,Test Labs Service start here -->
            <div class="container ourserviceback">
                <div class="row">
                    <div class=" col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="box-part text-center oveService"  routerLink="/doklist">
                            <i class="fa fa-user-md fa-6" style="font-size: 100px; color: white;" aria-hidden="true"></i>
                            <h5>DOCTORS</h5>
                        </div>
                    </div>
                    <div class=" col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="box-part text-center oveService"  routerLink="/allhoslist">
                            <i class="fa fa-h-square" style="font-size: 100px; color: white;" aria-hidden="true"></i>
                            <h5>HOSPITALS</h5>
                        </div>
                    </div>
                    <div class=" col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="box-part text-center oveService" routerLink="/alltestlablist">
                            <i class="fa fa-tint" style="font-size: 100px; color: red;" aria-hidden="true"></i>
                            <h5 >TEST LABS</h5>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Doctor,Hospitals,Test Labs Service end here -->

            <!-- All Doctor list start here -->


            <div class="container">
                <h6>TOP DOCTORS</h6>
                <h6 style="text-align: end;" routerLink="/doklist">View All</h6>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngFor="let multiDoc of docArray;let index = index ">
                            <div class="box-part text-center" routerLink="/sindok" [queryParams]="{id:multiDoc._id}" >
                            <div class="img">
                               
                                <img [src]=" serverip + '/' + multiDoc?.profileImage" style="width: 80%;" alt="">
                            </div>
                            <div>
                                <span> <td class="text-cent" ><b>{{ multiDoc.name }}</b></td></span>
                            </div>
                            <span *ngFor="let sinDeg of multiDoc.degree">
                                {{ sinDeg }}</span>
                            <div class="text">
                                {{ multiDoc.doctorType ? multiDoc.doctorType.name : "NA" }}
                            </div>
                            <button class="btn btn-primary">Book Appointment</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 dok-med"routerLink="/medicalhist">
                            <img src="../../../assets/m1histry.png" style="width:60%;" alt="">
                            <h1>MEDICAL HISTORY</h1>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 dok-med" routerLink="/dokcategory">
                            <img src="../../../assets/dokcat.jpg" style="width:90%;" alt="">

                            <h1>DOCTOR CATEGORY</h1>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Medical History, Doctors Category Start here -->

            <!-- Patient Main Body end here-->
        </div>
    </div>
</body>